import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

const selectCatalogFilter = (state: AppStateType) => state.catalogFilter;

const selectOrderingFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.ordering,
);

const selectSearchFilter = createSelector([selectCatalogFilter], catalogFilter => catalogFilter.complexFilters.search);

const selectWishlistFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.wishlist,
);

const selectPriceRangeMaxFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.priceRangeMax,
);

const selectPriceRangeMinFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.priceRangeMin,
);

const selectStyleCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.styles,
);

const selectAvailableStylesCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.styles?.availableValues,
);

const selectFormatCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.formats,
);

const selectCharacteristicCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.characteristics,
);

const selectOriginCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.origins,
);

const selectMoodCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.simpleFilters?.moods,
);

const selectRatingCatalogFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.rating,
);

const selectUpdatedFilterValuesTime = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.filterApplyTrigger,
);

const selectPromotionToggleFilter = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.complexFilters.promotion,
);

const selectAllFiltersData = createSelector([selectCatalogFilter], catalogFilter => ({
  ...catalogFilter.complexFilters,
  ...catalogFilter.simpleFilters,
}));

const selectIsFilterStatsLoaded = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.isFilterStatsLoaded,
);

const selectIsFilterStatsLoading = createSelector(
  [selectCatalogFilter],
  catalogFilter => catalogFilter.isFilterStatsLoading,
);

export {
  selectCatalogFilter,
  selectOrderingFilter,
  selectAllFiltersData,
  selectMoodCatalogFilter,
  selectOriginCatalogFilter,
  selectPromotionToggleFilter,
  selectRatingCatalogFilter,
  selectPriceRangeMaxFilter,
  selectPriceRangeMinFilter,
  selectWishlistFilter,
  selectStyleCatalogFilter,
  selectSearchFilter,
  selectFormatCatalogFilter,
  selectCharacteristicCatalogFilter,
  selectUpdatedFilterValuesTime,
  selectAvailableStylesCatalogFilter,
  selectIsFilterStatsLoaded,
  selectIsFilterStatsLoading,
};
